"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var MistBase_1 = require("./MistBase");
var MistWorker = require("worker-loader?inline=true&fallback=false!./worker");
var types_1 = require("./types");
var MistThreaded = (function (_super) {
    __extends(MistThreaded, _super);
    function MistThreaded(config, files) {
        var _this = _super.call(this, config, files) || this;
        _this.listenToMessages = function () {
            _this.worker.onmessage = function (message) {
                var _a = message.data, id = _a.id, type = _a.type, progress = _a.progress, data = _a.data, cancelId = _a.cancelId, reason = _a.reason, awsObjectKey = _a.awsObjectKey;
                switch (type) {
                    case (types_1.WorkerMessages.PROGRESS):
                        _this.onProgress(progress, id);
                        break;
                    case (types_1.WorkerMessages.SUCCESS):
                        _this.onSuccess(id, data, awsObjectKey);
                        _this.completedFiles += 1;
                        break;
                    case (types_1.WorkerMessages.START):
                        var cancel = _this.generateCancel(cancelId);
                        _this.onStart(cancel, id);
                        break;
                    case (types_1.WorkerMessages.ERROR):
                        _this.onError(reason, id);
                        _this.completedFiles += 1;
                }
                _this.checkCompletion();
            };
        };
        _this.generateCancel = function (id) { return (function () {
            _this.completedFiles += 1;
            _this.checkCompletion();
            _this.worker.postMessage({ id: id, type: types_1.WorkerMessages.CANCEL });
        }); };
        _this.checkCompletion = function () {
            if (_this.completedFiles === _this.numFiles) {
                _this.worker.terminate();
            }
        };
        _this.updateConfig = function (config) { return _this.worker.postMessage({ type: types_1.WorkerMessages.CONFIG, config: config }); };
        var fileMeta = files.map(function (file) { return file.file.id; });
        _this.numFiles = files.length;
        _this.completedFiles = 0;
        _this.worker = new MistWorker();
        _this.listenToMessages();
        _this.worker.postMessage({
            type: types_1.WorkerMessages.UPLOAD,
            config: config,
            files: files,
            fileMeta: fileMeta
        });
        return _this;
    }
    return MistThreaded;
}(MistBase_1.default));
exports.default = MistThreaded;
